import { GridColDef, GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid-pro'
import { gridFormatters, gridValueGetters } from 'src/utils/grid'
import { TableTags } from 'src/components/tags/TableTags'
import { Tag } from 'src/interfaces/tag'
import { MC } from 'src/interfaces/mc'
import { mcStatusTitles } from './constants'
import { MCStatusChip } from 'src/components/mc-list/shared/MCStatusChip'
import { MCStatus } from './enums'
import { NavigatorChip } from 'src/components/shared/NavigatorChip'
import { ROUTES } from '../routes'

const sharedContractorColumns: Array<GridColDef> = [
  {
    field: 'id',
    headerName: 'ID',
    flex: 2,
    sortable: true,
    valueGetter: (params: GridValueGetterParams<MC>) => params.row.masterContractorExternalId,
  },
  {
    field: 'displayName',
    headerName: 'Name',
    flex: 2,
    sortable: true,
    valueGetter: (params: GridValueGetterParams<MC>) => params.row.companyName,
  },
]

const statusCol = {
  field: 'status',
  headerName: 'Status',
  flex: 2,
  sortable: false,
  valueGetter: (params: GridValueGetterParams<MC>) => mcStatusTitles[params.row.status],
  renderCell: (params: GridRenderCellParams<MC>) => {
    return <MCStatusChip status={params.row.status} />
  },
}

const lastColumns = [
  {
    field: 'tags',
    headerName: 'Tag(s)',
    flex: 3,
    sortable: false,
    sortComparator: (v1: Tag[], v2: Tag[]) => {
      return v1.length - v2.length
    },
    renderCell: (params: GridRenderCellParams<MC>) =>
      params.row?.tags.length ? <TableTags tags={params.row?.tags || []} /> : <span>-</span>,
  },
  {
    field: 'contractorsCount',
    headerName: 'Sub contractors',
    flex: 2,
    sortable: false,
    renderCell: (params: GridRenderCellParams<MC>) =>
      params.row?.contractorsCount ? (
        <NavigatorChip
          text="contractor"
          count={params.row.contractorsCount}
          targetId={params.row.masterContractorRelationId}
          stateKey="masterContractorRelationId"
          url={ROUTES.CONTRACTORS_URL}
        />
      ) : (
        <span>-</span>
      ),
  },
]

export const mcColumns = {
  [MCStatus.Activated]: [
    ...sharedContractorColumns,
    statusCol,
    {
      field: 'activatedAt',
      headerName: 'Date onboarded',
      flex: 2,
      sortable: true,
      valueGetter: gridValueGetters.parseDate,
      valueFormatter: gridFormatters.formatShortDate,
    },
    ...lastColumns,
  ],
  [MCStatus.Deactivated]: [
    ...sharedContractorColumns,
    {
      field: 'deactivatedAt',
      headerName: 'Date deactivated',
      flex: 2,
      sortable: true,
      valueGetter: gridValueGetters.parseDate,
      valueFormatter: gridFormatters.formatShortDate,
    },
    ...lastColumns,
  ],
  [MCStatus.Invited]: [],
  [MCStatus.Rejected]: [],
}

export const mcInitialSortFields = {
  [MCStatus.Activated]: 'activatedAt',
  [MCStatus.Deactivated]: 'deactivatedAt',
  [MCStatus.Invited]: undefined,
  [MCStatus.Rejected]: undefined,
}

export const mcPageSizeOptions = [100, 250, 500, 1000]

export const MCS_COLUMNS_KEY = 'mcsColumns'
